import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { InvoicesDataProvider } from '@services/invoice/invoices-data-service/invoices.data.service';
import { PaymentsServiceProvider } from '@services/payments/payments-service/payments.service';
import { QuoteUpdateService } from '@services/quote/quote-update.service';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { PaymentsDataServiceProvider } from '@services/payments/payments-data-service/payments.data.service';
import { Summary } from '@models/models';

@Component({
	selector: 'payment-schedule',
	template: require('./payment-schedule.html'),
	styles: [require('./payment-schedule.scss')]
})
export class PaymentScheduleComponent {
	@Input('paymentScheduleNames') paymentScheduleNames;
	@Input('defaultPaymentScheduleNames') defaultPaymentScheduleNames;
	@Input('paymentScheduleTemplateId') paymentScheduleTemplateId;
	@Input('payments') payments;
	@Input('issueDate') issueDate;
	@Input('jobStartDate') jobStartDate;
	@Input('currencySymbol') currencySymbol;
	@Input('datePlaceHolder') datePlaceHolder;
	@Input('job') job;
	@Input('quoteTotal') quoteTotal: number;
	@Input('isFixed') isFixed: boolean;
	@Input('paymentsFromServer') paymentsFromServer;
	@Input('paymentScheduleIdFromServer') paymentScheduleIdFromServer: number;
	@Input('isInvoice') isInvoice: boolean;
	@Input('summary') summary: Summary;
	@Output() paymentScheduleChange = new EventEmitter();
	isPartlyPaid: boolean;
	chosenPaymentSchedule;
	templateFromServer;
	paymentsToShow = [];
	now = this.quoteUpdateService.getNowTextFormat();
	hidePaymentSchedule = false;
	hidePayments = true;
	shouldGetDefaultPayments = true;
	paymentScheduleText: string;
	isShowInformationBlock = false;

	get paymentSchedule() {
		return this.chosenPaymentSchedule;
	}

	@Input('paymentSchedule')
	set paymentSchedule(value) {
		this.chosenPaymentSchedule = value;
		if (value) {
			this.templateFromServer = this.job.paymentScheduleId;
			this.addSelectedSchedule(value);
		}
	}

	ngAfterViewInit(): void {
		switch (this.paymentScheduleTemplateId) {
			case -1:
			case -2:
				this.getPaymentScheduleNew(this.paymentScheduleTemplateId, true);
				break;
			case -3:
				this.getPaymentScheduleNew(this.paymentScheduleTemplateId, false);
				break;
			default:
				this.getPaymentScheduleNew(0, false);
				break;
		}
		if (this.paymentScheduleTemplateId !== -3) {
			this.hidePaymentSchedule = this.quoteTotal === 0;
		}

		this.isPartlyPaid =
			this.paymentService.isPaidPayments(this.payments) ||
			this.paymentService.isWrittenOffPayments(this.payments);
		this.paymentScheduleText = `Assign a payment schedule to this ${
			this.isInvoice ? 'invoice' : 'quote'
		}`;
	}

	constructor(
		private quoteUpdateService: QuoteUpdateService,
		private invoicesDataService: InvoicesDataProvider,
		private paymentService: PaymentsServiceProvider,
		private stringModifierService: StringModifierServiceProvider,
		private timeService: TimeServiceProvider,
		private paymentsDataService: PaymentsDataServiceProvider
	) {}

	addSelectedSchedule(schedule): void {
		schedule.name = this.stringModifierService.addSelectedText(schedule.name);
		schedule.id = 0;
		this.paymentScheduleNames.push(schedule);
		this.paymentScheduleTemplateId = schedule.id;
	}

	emitPaymentsChanges(): void {
		this.payments = this.paymentsToShow;
		this.paymentScheduleChange.emit({
			id: this.paymentScheduleTemplateId,
			payments: this.paymentsToShow
		});
	}

	getPaymentScheduleNew(
		paymentScheduleId: number,
		needToSendPayments: boolean,
		quoteTotal?: number,
		refreshAmount?: boolean,
		applyTemplate?: boolean
	) {
		if (applyTemplate === true) {
			this.isShowInformationBlock = false;
		}
		if (refreshAmount) {
			this.paymentScheduleTemplateId = paymentScheduleId;
		} else if (this.paymentScheduleTemplateId != 0) {
			this.paymentScheduleTemplateId = paymentScheduleId;
		}
		this.hidePayments = false;
		if (quoteTotal != null) {
			this.quoteTotal = quoteTotal;
			if (quoteTotal === 0) {
				this.hideAndResetPaymentSchedule();
			} else if (
				this.paymentScheduleTemplateId !== -3 &&
				this.paymentScheduleTemplateId !== -1
			) {
				this.hidePaymentSchedule = this.quoteTotal === 0;
			}
		}
		if (
			(needToSendPayments &&
				+paymentScheduleId === 0 &&
				this.shouldGetDefaultPayments) ||
			(refreshAmount &&
				+paymentScheduleId === 0 &&
				this.shouldGetDefaultPayments)
		) {
			paymentScheduleId = +this.paymentScheduleIdFromServer;
			this.payments = this.formPaymentsToShow(
				JSON.parse(JSON.stringify(this.paymentsFromServer))
			);
			needToSendPayments = true;
		}
		if (+paymentScheduleId === 0 && this.shouldGetDefaultPayments) {
			this.paymentsToShow = this.formPaymentsToShow(
				JSON.parse(JSON.stringify(this.paymentsFromServer))
			);
			this.emitPaymentsChanges();
		} else if (+paymentScheduleId > 0) {
			const paymentScheduleObject = { id: +paymentScheduleId };
			this.formPaymentsNew(paymentScheduleObject, needToSendPayments);
		} else if (+paymentScheduleId === -2) {
			this.formPaymentsNew({ id: +paymentScheduleId }, needToSendPayments);
		} else {
			this.emitPaymentsChanges();
			this.hidePayments = true;
		}
		if (!this.shouldGetDefaultPayments) {
			this.shouldGetDefaultPayments = true;
		}
	}

	hideAndResetPaymentSchedule() {
		if (
			this.paymentScheduleTemplateId !== -3 &&
			this.paymentScheduleTemplateId !== -1
		) {
			this.hidePaymentSchedule = this.quoteTotal === 0;
		} else {
			this.hidePayments = true;
		}
	}

	formPaymentsNew(paymentSchedule, needToSendPayments: boolean) {
		if (
			paymentSchedule.id === 0 ||
			paymentSchedule.id === this.templateFromServer
		) {
			this.job.paymentScheduleId = 0;
		} else {
			this.job.paymentScheduleId = this.templateFromServer;
		}
		if (!this.quoteTotal) {
			this.quoteTotal = 0;
		}

		if (this.paymentScheduleTemplateId !== 0 || needToSendPayments) {
			this.payments.map(payment => delete payment.date);

			const paymentsToCalculate = this.generatePayments(
				paymentSchedule,
				needToSendPayments
			);

			this.paymentsDataService
				.calculatePaymentSchedule(paymentsToCalculate)
				.subscribe(data => {
					if (data.reordered === true) {
						this.isShowInformationBlock = true;
					}
					this.paymentsToShow = [];
					this.paymentsToShow = this.formPaymentsToShow(data.payments);
					this.hidePayments = false;
					this.emitPaymentsChanges();
				});
		} else {
			this.paymentsToShow = [];
			this.paymentsToShow = this.formPaymentsToShow(this.payments);

			this.emitPaymentsChanges();
		}
	}

	getTemplateId() {
		switch (+this.paymentScheduleTemplateId) {
			case 0:
				return this.templateFromServer;
			case -1:
			case -2:
				return null;
			default:
				return this.paymentScheduleTemplateId;
		}
	}

	generatePayments(paymentSchedule, needToSendPayments: boolean) {
		const paymentScheduleToReturn = this.getTemplateId();
		return {
			paymentScheduleId: paymentScheduleToReturn,
			jobDate: this.job.startDate,
			invoiceIssueDate: this.quoteUpdateService.getDate(this.issueDate.jsdate),
			totalAmount: this.quoteTotal,
			currencySymbol: this.currencySymbol,
			payments: needToSendPayments ? this.payments : [],
			invoiceOrQuote: this.isInvoice
		};
	}

	private formPaymentsToShow(payments) {
		return payments.map(payment => {
			let date;
			if (
				payment.paymentDateWithRule &&
				payment.paymentDateWithRule.estimatedDate
			) {
				date = this.quoteUpdateService.setQuoteIssueDate(
					payment.paymentDateWithRule.estimatedDate
				);
			} else if (!payment.paymentDateWithRule && payment.paymentDate) {
				date = this.quoteUpdateService.setQuoteIssueDate(payment.paymentDate);
			} else {
				date = null;
			}

			return Object.assign(payment, {
				date,
				schedule: `${payment.paymentSchedulePart.amount}${this.setAmountType(
					payment.paymentSchedulePart.type
				)}`
			});
		});
	}

	setAmountType(type): string {
		switch (type) {
			case 'Percent of order':
				return '% of order';
			case 'Percent of remaining balance':
				return '% of remaining balance';
			default:
				return '';
		}
	}

	changePayments(date, index): void {
		if (this.payments[index].paymentDateWithRule) {
			this.payments[index].paymentDateWithRule.estimatedDate =
				date === null ? null : this.quoteUpdateService.getDate(date.jsdate);
		}
		this.payments[index].paymentDate =
			date === null ? null : this.quoteUpdateService.getDate(date.jsdate);

		this.payments[index].due =
			date === null ? null : this.quoteUpdateService.getDate(date.jsdate);
		const paymentScheduleIdToGet =
			this.paymentScheduleTemplateId === 0
				? this.paymentScheduleIdFromServer
				: this.paymentScheduleTemplateId;

		this.shouldGetDefaultPayments = false;

		this.getPaymentScheduleNew(paymentScheduleIdToGet, true, this.quoteTotal);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quotes/common/payment-schedule/payment-schedule.ts